// extracted by mini-css-extract-plugin
export default {"animation-fast-ms":"300","animation-slow-ms":"800","container":"menu_container__khTzg","background":"menu_background__105H0","navigationGroups":"menu_navigationGroups__3utSd"};